import * as React from "react";
import Paper from "material-ui/Paper";
import Avatar from "material-ui/Avatar";
import classNames from "classnames";
import { DATATEST } from "constants/integration";

interface IProps {
    message: any;
    onOpenDeleteDialog?: any;
    me: any;
    index: number;
    color?: string;
}

export class Message extends React.PureComponent<IProps, any> {
    muiStyles = {
        paper: {
            margin: "6px 0",
            padding: "10px",
            boxShadow: "none",
            borderRadius: "5px",
        },
        avatar: {
            marginTop: "0px",
            marginRight: "10px",
            position: "absolute",
            top: "7px",
            left: "3px",
            zIndex: "10",
        },
        menu: {
            position: "absolute",
            right: "0px",
            top: "0px",
        },
        menuItem: {
            position: "absolute",
            right: "5px",
            top: "16px",
            width: "48px",
        },
        iconMenu: {
            position: "absolute",
            right: "0px",
            top: "0px",
        },
    };

    getInitials(message) {
        if (message.identity_info && message.identity_info.display_name) {
            let initals = "";
            const chunks = message.identity_info.display_name.split(" ");
            for (let i = 0; i < chunks.length; i++) {
                if (i >= 2) {
                    break;
                }
                initals = initals + (chunks[i][0] || "");
            }
            return initals.toUpperCase();
        } else {
            return null;
        }
    }

    render() {
        const { message, index, color } = this.props;
        const userInfo = message.identity_info ? message.identity_info.display_name : null;

        if (message && message.id && message.id !== "beginning") {
            const myMessage = message.identity === this.props.me._id;
            return (
                <div
                    key={index}
                    data-index={index}
                    className={classNames({ message: true, owned: myMessage })}
                    data-test={DATATEST.ASSORTMENTS.CHAT_MESSAGE}
                >
                    {!myMessage && userInfo && (
                        <Avatar size={32} style={this.muiStyles.avatar as any} backgroundColor={color}>
                            {this.getInitials(message)}
                        </Avatar>
                    )}
                    <Paper
                        className={classNames({ messageContent: true, owned: myMessage })}
                        style={this.muiStyles.paper as any}
                    >
                        <div>
                            {!myMessage && userInfo && <h3>{message.identity_info.display_name}</h3>}
                            <p>{message.content}</p>
                            <div className={classNames({ timestamp: true, owned: myMessage })}>
                                {message.timestamp_ms.fromNow()}
                            </div>
                        </div>
                        {/* {myMessage &&
                            <IconMenu
                                style={this.muiStyles.iconMenu as any}
                                iconButtonElement={<IconButton><MoreHorizIcon /></IconButton>}
                            >
                                <MenuItem
                                    data-test="delete-chat-message"
                                    primaryText={formatMessage("Delete")}
                                    onClick={this.props.onOpenDeleteDialog.bind(this, message)}
                                />
                            </IconMenu>
                        } */}
                        <div className={myMessage ? "directional" : "directionalAlt"}>
                            <div className={myMessage ? "taper" : "taperLeft"} />
                        </div>
                    </Paper>
                </div>
            );
        } else if (message && message.id === "beginning") {
            return (
                <div
                    data-test={DATATEST.ASSORTMENTS.CHAT_BEGINNING}
                    key={index}
                    className={"messageInstructions beginningOfHistory"}
                >
                    {message.content}
                </div>
            );
        } else {
            return null;
        }
    }
}
